import UIIcon from 'UIComponents/icon/UIIcon';
import UIList from 'UIComponents/list/UIList';
import styled, { theme } from 'academy-common-lib/utils/Styling';
import FormattedMessage from 'I18n/components/FormattedMessage';
// @ts-expect-error Could not find a declaration file for module
import FormattedDuration from 'I18n/components/FormattedDuration';
import ACIcon from '../icon/ACIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Icon = styled(UIIcon).attrs({
  color: theme.colors.EERIE,
  size: 24
}).withConfig({
  displayName: "ACContentBreakdownList__Icon",
  componentId: "sc-121ru0y-0"
})(["position:relative;top:4px;margin-right:4px !important;"]);
const ACContentBreakdownList = ({
  certificateCount,
  lessonCount,
  videoCount,
  quizCount,
  exerciseCount,
  resourceCount,
  duration
}) => {
  return /*#__PURE__*/_jsxs(UIList, {
    childClassName: "m-right-4 m-bottom-2 p-x-0 p-y-0",
    inline: true,
    children: [!!certificateCount && /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(Icon, {
        name: "certification"
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academyCommon.contentBreakdown.numCertifications",
        options: {
          count: certificateCount
        }
      })]
    }), !!lessonCount && /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(Icon, {
        name: "lesson"
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: `academyCommon.contentBreakdown.numLessons`,
        options: {
          count: lessonCount
        }
      })]
    }), !!videoCount && /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(ACIcon, {
        className: "m-right-1",
        name: "video",
        size: 22,
        style: {
          position: 'relative',
          top: 6
        }
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: `academyCommon.contentBreakdown.numVideos`,
        options: {
          count: videoCount
        }
      })]
    }), !!quizCount && /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(ACIcon, {
        className: "m-right-1",
        name: "quiz",
        size: 22,
        style: {
          position: 'relative',
          top: 6
        }
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: `academyCommon.contentBreakdown.numQuizzes`,
        options: {
          count: quizCount
        }
      })]
    }), !!exerciseCount && /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(Icon, {
        name: "registration"
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: `academyCommon.contentBreakdown.numPracticalExercises`,
        options: {
          count: exerciseCount
        }
      })]
    }), !!resourceCount && /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(Icon, {
        name: "salesTemplates"
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academyCommon.contentBreakdown.resources",
        options: {
          count: resourceCount
        }
      })]
    }), !!duration && /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(Icon, {
        name: "time"
      }), /*#__PURE__*/_jsx(FormattedDuration, {
        format: "medium",
        from: +new Date() - duration * 1000
      })]
    })]
  });
};
export default ACContentBreakdownList;